import { render } from "./strat_grid_amchart2.vue?vue&type=template&id=4e12cb40&scoped=true"
import script from "./strat_grid_amchart2.vue?vue&type=script&lang=js"
export * from "./strat_grid_amchart2.vue?vue&type=script&lang=js"

import "./strat_grid_amchart2.vue?vue&type=style&index=0&id=4e12cb40&scoped=true&lang=css"

import exportComponent from "E:\\Source\\HuasCo\\personal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e12cb40"]])

export default __exports__